(() => {
  const root = document.querySelector('.ted-home');
  if (!root || !document.body.classList.contains('ted-home-page')) return;

  const videos = root.querySelectorAll('video');
  videos.forEach((video) => {
    video.addEventListener('play', () => {
      videos.forEach((other) => {
        if (other !== video) other.pause();
      });
    });
  });

  const toggle = root.querySelector('[data-ted-nav-toggle]');
  const drawer = root.querySelector('[data-ted-nav-drawer]');
  if (toggle && drawer) {
    const setOpen = (open) => {
      drawer.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.classList.toggle('ted-home-nav-open', open);
    };
    toggle.addEventListener('click', () => setOpen(drawer.hidden));
    drawer.querySelectorAll('a').forEach((a) => a.addEventListener('click', () => setOpen(false)));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') setOpen(false);
    });
  }

  const hideChatWidgets = () => {
    // Never force-hide Shopify Inbox here — ted-shell-chat.js manages dormancy
    // and programmatic open via <shopify-chat>.show(). Only hide the WhatsApp pill.
    document.querySelectorAll('.ted-whatsapp-button').forEach((el) => {
      el.style.setProperty('display', 'none', 'important');
      el.setAttribute('aria-hidden', 'true');
    });
  };

  const pinCookieBanner = () => {
    const candidates = [
      ...document.querySelectorAll('#shopify-pc__banner, .shopify-pc__banner, [id^="shopify-pc"]'),
      ...[...document.querySelectorAll('[role="dialog"]')].filter((el) =>
        /cookie|consent|confidentialit/i.test(el.textContent || '')
      ),
    ];
    candidates.forEach((el) => {
      if (!el || el.dataset.tedHomeCookiePinned) return;
      el.dataset.tedHomeCookiePinned = '1';
      el.style.setProperty('position', 'fixed', 'important');
      el.style.setProperty('left', '0', 'important');
      el.style.setProperty('right', '0', 'important');
      el.style.setProperty('bottom', window.matchMedia('(max-width: 600px)').matches ? '64px' : '0', 'important');
      el.style.setProperty('top', 'auto', 'important');
      el.style.setProperty('transform', 'none', 'important');
      el.style.setProperty('z-index', '40', 'important');
      el.style.setProperty('max-width', '100%', 'important');
      el.style.setProperty('width', '100%', 'important');
      el.style.setProperty('margin', '0', 'important');
    });
  };

  hideChatWidgets();
  pinCookieBanner();

  const mo = new MutationObserver(() => {
    hideChatWidgets();
    pinCookieBanner();
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('load', () => {
    hideChatWidgets();
    pinCookieBanner();
  });
})();
